import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Content from "./content";
import Header from "./header";

export default function App() {
  const [menuOpen, setMenuOpen] = React.useState(false);

  return (
    <Router>
      <div className="app dark">
        <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <Routes>
          <Route path="/home" element={<Content />} />
          <Route path="/" element={<Content />} />
        </Routes>

   <footer className="footer" role="contentinfo">
  <div className="footer-content">
    
    <div className="footer-text">
      <p>© {new Date().getFullYear()} Pairian Ltd. All rights reserved.</p>
      <p>Registered in England & Wales · Company No. 17065764</p>
      <p>London, UK</p>
      <p>
        <a
          href="https://www.linkedin.com/company/pairian"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
      </p>
    </div>
  </div>
</footer>


      </div>
    </Router>
  );
}
